// cover images files
import doa_cover from "../assets/images/doa-cover.jpg"
import cola_cover from "../assets/images/cola-cover.jpg"

// audios files
import CALLIE from "../assets/audios/CALLIE.mp3"
import JUU from "../assets/audios/JUU.mp3"
import KARIA from "../assets/audios/KARIA.mp3"
import KILODE from "../assets/audios/KILODE.mp3"
import MAKA from "../assets/audios/MAKA.mp3"
import ONME from "../assets/audios/ON ME.mp3"
import PHOLO from "../assets/audios/PHOLO.mp3"
import SENSEMA from "../assets/audios/SENSEMA.mp3"
import SPIRITUAL from "../assets/audios/SPIRITUAL.mp3"
import SWING from "../assets/audios/SWING.mp3"
import tellme from "../assets/audios/tell me.mp3"
import THEROAD from "../assets/audios/THE ROAD.mp3"
import WINE from "../assets/audios/WINE.mp3"
import YALE from "../assets/audios/YALE.mp3"
import ZLA from "../assets/audios/ZLA.mp3"

const audios = [
  {
    id: 1,
    title: "Callie",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: CALLIE,
    coverImg: cola_cover,
    featured: false,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 2,
    title: "Juu",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: JUU,
    coverImg: doa_cover,
    featured: true,
    cost: "80,000",
    type: "audio/mp3",
  },
  {
    id: 3,
    title: "Karia",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: KARIA,
    coverImg: cola_cover,
    featured: false,
    cost: "90,000",
    type: "audio/mp3",
  },
  {
    id: 4,
    title: "Kilode",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: KILODE,
    coverImg: doa_cover,
    featured: true,
    cost: "100,000",
    type: "audio/mp3",
  },
  {
    id: 5,
    title: "Maka",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: MAKA,
    coverImg: cola_cover,
    featured: true,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 6,
    title: "On Me",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: ONME,
    coverImg: doa_cover,
    featured: false,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 7,
    title: "Pholo",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: PHOLO,
    coverImg: cola_cover,
    featured: true,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 8,
    title: "Sensema",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: SENSEMA,
    coverImg: cola_cover,
    featured: true,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 9,
    title: "Spiritual",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: SPIRITUAL,
    coverImg: doa_cover,
    featured: false,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 10,
    title: "Swing",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: SWING,
    coverImg: doa_cover,
    featured: true,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 11,
    title: "Tell Me",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: tellme,
    coverImg: doa_cover,
    featured: false,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 12,
    title: "The Road",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: THEROAD,
    coverImg: doa_cover,
    featured: true,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 13,
    title: "Wine",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: WINE,
    coverImg: doa_cover,
    featured: true,
    cost: "70,000",
    type: "audio/mp3",
  },
  {
    id: 14,
    title: "Yale",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: YALE,
    coverImg: doa_cover,
    featured: true,
    cost: "75,000",
    type: "audio/mp3",
  },
  {
    id: 15,
    title: "ZLA",
    descr:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
    src: ZLA,
    coverImg: doa_cover,
    featured: true,
    cost: "60,000",
    type: "audio/mp3",
  },
]

export default audios
